import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// tslint:disable max-classes-per-file
import { AuthorizationError, AuthorizationRequestHandler, AuthorizationResponse, BasicQueryStringUtils, DefaultCrypto } from '@openid/appauth';
import { CHECK_FOR_POPUP_CLOSE_INTERVAL, DEFAULT_POPUP_FEATURES } from '../constants';
import { parseUrlParams } from '../utils/callback';
import { PopupValidator } from '../utils/popup-validator'; // Intermediate errors, since AuthorizationRequestHandler must return an AuthorizationError instance.
// These should not be user visible.

export var PopupClosedError = /*#__PURE__*/function (_AuthorizationError) {
  _inherits(PopupClosedError, _AuthorizationError);

  var _super = _createSuper(PopupClosedError);

  function PopupClosedError() {
    _classCallCheck(this, PopupClosedError);

    return _super.call(this, {
      error: 'The popup was dismissed.'
    });
  }

  return PopupClosedError;
}(AuthorizationError);
export var PopupBlockedError = /*#__PURE__*/function (_AuthorizationError2) {
  _inherits(PopupBlockedError, _AuthorizationError2);

  var _super2 = _createSuper(PopupBlockedError);

  function PopupBlockedError() {
    _classCallCheck(this, PopupBlockedError);

    return _super2.call(this, {
      error: 'The popup was blocked.'
    });
  }

  return PopupBlockedError;
}(AuthorizationError); // Create a popup feature string from an object with keys and values

function createPopupFeatureString(features) {
  // Convert to array of strings
  var featuresArray = Object.keys(features).reduce(function (arr, key) {
    var value = features[key]; // convert to feature string format: top=100

    arr.push("".concat(key, "=").concat(value));
    return arr;
  }, Array()); // Join strings with ',' and finish with ';'

  return featuresArray.join(',') + ';';
} // Returns a set of attributes for a centered popup based on
// the default values from constants.ts


function createCenteredPopupFeatures() {
  var windowFeatures = DEFAULT_POPUP_FEATURES;
  var w = windowFeatures.width;
  var h = windowFeatures.height; // Fixes dual-screen position

  var dualScreenLeft = window.screenLeft || window.screenX;
  var dualScreenTop = window.screenTop || window.screenY;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
  var left = windowWidth / 2 - w / 2;
  var top = windowHeight / 2 - h / 2;
  windowFeatures.left = left + dualScreenLeft;
  windowFeatures.top = top + dualScreenTop;
  return windowFeatures;
}

export var PopupRequestHandler = /*#__PURE__*/function (_AuthorizationRequest) {
  _inherits(PopupRequestHandler, _AuthorizationRequest);

  var _super3 = _createSuper(PopupRequestHandler);

  function PopupRequestHandler() {
    var _this;

    var utils = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BasicQueryStringUtils();
    var crypto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new DefaultCrypto();

    _classCallCheck(this, PopupRequestHandler);

    _this = _super3.call(this, utils, crypto);
    _this.popupWindow = null;
    _this.isCancelled = false;
    _this.isBlocked = false; // Watch for the popup being blocked

    _this.validator = new PopupValidator(function () {
      // Return a specific error if blocked, so that we can handle it appropriately.
      _this.isBlocked = true;

      _this.completeAuthorizationRequestIfPossible();
    });
    return _this;
  }

  _createClass(PopupRequestHandler, [{
    key: "performAuthorizationRequest",
    value: function performAuthorizationRequest(configuration, request) {
      var url = this.buildRequestUrl(configuration, request);
      this.pendingRequest = request;
      this.id = request.state; // Set a unique handler on the main window

      window["popupCallback_".concat(request.state)] = this.callback.bind(this); // Start monitoring to see if the popup has been closed

      this.closedTimer = window.setInterval(this.checkPopup.bind(this), CHECK_FOR_POPUP_CLOSE_INTERVAL); // Create features for popup

      var windowFeatures = createCenteredPopupFeatures(); // Create popup window

      this.popupWindow = window.open(url, '_blank', createPopupFeatureString(windowFeatures)); // Check if the popup we just created was blocked.

      this.validator.check(this.popupWindow); // Focus the popup to bring it to the front

      if (this.popupWindow) {
        this.popupWindow.focus();
      }
    }
  }, {
    key: "callback",
    value: function callback(url) {
      this.responseUrl = url;
      this.completeAuthorizationRequestIfPossible();
    } // Custom implementation to remove excess log spam

  }, {
    key: "completeAuthorizationRequestIfPossible",
    value: function completeAuthorizationRequestIfPossible() {
      var _this2 = this;

      return this.completeAuthorizationRequest().then(function (result) {
        if (result && _this2.notifier) {
          _this2.notifier.onAuthorizationComplete(result.request, result.response, result.error);
        }
      });
    }
  }, {
    key: "completeAuthorizationRequest",
    value: function completeAuthorizationRequest() {
      var request = this.pendingRequest; // Assert there is a pending request

      if (!request) {
        return Promise.resolve(null);
      } // Assert the request wasn't cancelled


      if (this.isCancelled === true) {
        return this.respondWithCancelled(request);
      }

      if (this.isBlocked === true) {
        return this.respondWithBlocked(request);
      } // Assert there is no error


      if (this.error) {
        return this.respondWithError(request, this.error.message);
      } // Assert there is a response url to parse


      if (!this.responseUrl) {
        return Promise.resolve(null);
      } // Parse the url into data


      var data = parseUrlParams(this.responseUrl); // Extra the state

      var state = data.state; // Validate state is same as request

      if (request.state !== state) {
        return Promise.resolve(null);
      } // Check for an error response


      var error = data.error;

      if (error) {
        // get additional optional info.
        var errorUri = data.error_uri;
        var errorDescription = data.error_description;
        return this.respondWithError(request, error, errorDescription, errorUri);
      } // Respond with a code


      var code = data.code;
      return this.respondWithCode(request, code);
    }
  }, {
    key: "respondWithBlocked",
    value: function respondWithBlocked(request) {
      var error = new PopupBlockedError();
      var response = {
        request: request,
        error: error,
        response: null
      };
      this.cleanup();
      return Promise.resolve(response);
    }
  }, {
    key: "respondWithCancelled",
    value: function respondWithCancelled(request) {
      var error = new PopupClosedError();
      var response = {
        request: request,
        error: error,
        response: null
      };
      this.cleanup();
      return Promise.resolve(response);
    }
  }, {
    key: "respondWithError",
    value: function respondWithError(request, errorMessage, errorDescription, errorUri) {
      var error = new AuthorizationError({
        error: errorMessage,
        error_description: errorDescription,
        error_uri: errorUri,
        state: request.state
      });
      var response = {
        request: request,
        error: error,
        response: null
      };
      this.cleanup();
      return Promise.resolve(response);
    }
  }, {
    key: "respondWithCode",
    value: function respondWithCode(request, code) {
      var authorizationResponse = null;

      if (code) {
        authorizationResponse = new AuthorizationResponse({
          code: code,
          state: request.state
        });
      }

      var response = {
        request: request,
        response: authorizationResponse,
        error: null
      };
      this.cleanup();
      return Promise.resolve(response);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      window.clearInterval(this.closedTimer);
      delete window["popupCallback_".concat(this.id)];

      if (this.popupWindow) {
        this.popupWindow.close();
      }

      this.popupWindow = null;
      this.pendingRequest = undefined;
      this.error = undefined;
      this.id = undefined;
      this.responseUrl = undefined;
    }
  }, {
    key: "checkPopup",
    value: function checkPopup() {
      if (this.popupWindow && this.popupWindow.closed) {
        // Stop checking
        window.clearInterval(this.closedTimer);
        this.isCancelled = true;
        this.completeAuthorizationRequestIfPossible();
      }
    }
  }]);

  return PopupRequestHandler;
}(AuthorizationRequestHandler);